import { render, staticRenderFns } from "./createChild.vue?vue&type=template&id=8a0c294e&"
import script from "./createChild.vue?vue&type=script&lang=js&"
export * from "./createChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports